import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/images/shareIcons/person.svg'


const _hoisted_1 = { class: "bg-modal h-full form-width" }
const _hoisted_2 = { class: "upper-part-size" }
const _hoisted_3 = {
  key: 0,
  class: "row w-full",
  style: {"margin-top":"-0.3rem"}
}
const _hoisted_4 = {
  class: "row gap-04 pad-s",
  style: {"margin-left":"auto"}
}
const _hoisted_5 = { class: "row-top" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "mtop-15"
}
const _hoisted_8 = { class: "mtop-04 col gap-06 scrollbox-size" }
const _hoisted_9 = { class: "w-full row" }
const _hoisted_10 = { class: "row-bottom gap-04" }
const _hoisted_11 = {
  key: 0,
  class: "row w-full mtop-auto"
}

import { ref, computed, onMounted, nextTick } from 'vue'
import { useAppUserStore } from '@/stores/appUser'
import { apiDateString, apiShortTimeString } from "@/api/apicommon"
import officeapi from "@/api/officeapi"
import {formatUTCDateTimeToDate, formatUTCDateTimeToTime} from "@/utils/date-utils";
import { useI18n } from "vue-i18n";
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useUiStore } from '@/stores/ui';
import { useRouter } from 'vue-router';
import { useToast } from 'primevue';
import { toastError } from '@/utils/toast-utils';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'taskNotesChat',
  props: {
  task: {
    type: Object,
    required: true,
  },
},
  emits: ['changed', 'validated', 'unvalidated'],
  setup(__props, { emit: __emit }) {

const props = __props

const { t } = useI18n();
const appUserStore = useAppUserStore();
const router = useRouter();
const currentEntryStore = useCurrentEntryStore();
const uiStore = useUiStore();
const toast = useToast();

const emits = __emit;

const taskNoteInputRef = ref("")
const focusRef = ref(null)

const originPageIsPatient = () => {
  return router.currentRoute.value.name === 'patient';
}

function setLoadingScreenTexts(pwrPatient) {
  const loadingText = PersonService.formatName(pwrPatient.firstName, pwrPatient.firstName);
  const loadingSubText = apiDateString(pwrPatient.birthDate);
  uiStore.setLoadingScreenText(loadingText);
  uiStore.setLoadingScreenSubText(loadingSubText);
}

const accessPatient = async (pwrPatient) => {
  if (pwrPatient?.personWithRoleId) {
    setLoadingScreenTexts(pwrPatient);
    currentEntryStore.clearCurrentEntry();
    router.push({
      name: "patient",
      params: { patientId: pwrPatient.personWithRoleId }
    });
  } else {
    toastError(toast, {
          summary: t('common.toast.error'),
          detail: t('error.REDIRECT')
      });
  }
}
const localTaskStatus = ref(props.task.taskStatus)

async function validateTask() {
  const taskId = props.task.taskId;
  localTaskStatus.value = 'Settled';
  emits('validated', officeapi.validateTask(taskId));
  uiStore.setModalUiId("");
}

async function unvalidateTask() {
  const taskId = props.task.taskId;
  localTaskStatus.value = 'Pending';
  emits('unvalidated', officeapi.unvalidateTask(taskId));
}

const pwrPatient = computed(() => {
  return props.task.pwrPatient
})

const appUserPwrId = computed(() => {
  return appUserStore.currentHealthGroupMembership?.pwr.personWithRoleId;
})
const localTaskNotes = ref([...props.task.taskNotes])

const taskNotes = computed(() => {
  return localTaskNotes.value
})

const hasUnreadNotes = computed(() => {
  return localTaskNotes.value.some(taskNote => taskNote.read === false)
})

async function postMessage() {
  if (taskNoteInputRef.value === "") return;
  //Backend
  const taskId = props.task.taskId
  const noteContent = taskNoteInputRef.value
  taskNoteInputRef.value = ""
  localTaskNotes.value.push({
    noteContent,
    appUserNoteCreator: { personWithRoleId: appUserPwrId.value, firstName: '' },
    updated: new Date().toISOString(),
    read: true
  })
  nextTick(() => scrollToBottom())
  emits('changed', officeapi.addNoteToTask(taskId, noteContent))
}

async function setTaskNotesAsRead() {
  if (!hasUnreadNotes.value) return;
  //Backend
  const taskId = props.task.taskId
  await officeapi.setTaskNotesAsRead(taskId)
}

const scrollbox = ref(null);
function scrollToBottom() {
  scrollbox.value.scrollTop = scrollbox.value.scrollHeight;
}

onMounted(() => {
  scrollToBottom();
  setTaskNotesAsRead();
  nextTick(() => {
    if (props.task.taskStatus === 'Pending') {
      focusRef.value.innerRef.focus()
    }
  })
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mtop-02" }, null, -1)),
      (localTaskStatus.value === 'Settled')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_text_item, {
                txt: "Validé le",
                styles: "font-s main-m"
              }),
              _createVNode(_component_text_item, {
                txt: _unref(apiDateString)(__props.task.updated),
                styles: "font-s main-m"
              }, null, 8, ["txt"]),
              _createVNode(_component_text_item, {
                txt: _unref(apiShortTimeString)(__props.task.updated),
                styles: "font-s main-m"
              }, null, 8, ["txt"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (pwrPatient.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_text_item, {
                class: "mleft-06 mtop-01 patient-name-max-w",
                txt: _unref(PersonService).formatName(pwrPatient.value.lastName, pwrPatient.value.firstName),
                styles: "font-l"
              }, null, 8, ["txt"]),
              (!originPageIsPatient())
                ? (_openBlock(), _createBlock(_component_buttonGroup, {
                    key: 0,
                    class: "align-center mleft-03 mtop-01",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (accessPatient(pwrPatient.value)))
                  }, {
                    default: _withCtx(() => [
                      _cache[6] || (_cache[6] = _createElementVNode("img", {
                        src: _imports_0,
                        class: "img-primary"
                      }, null, -1)),
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.actionButton.accessPatient'),
                        class: "mleft-05 txt-primary font-size-14"
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7)),
        (localTaskStatus.value === 'Pending')
          ? (_openBlock(), _createBlock(_component_button_group, {
              key: 2,
              styles: "border-m pad-s",
              class: "mleft-auto psides-10",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (validateTask()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: "Finaliser",
                  styles: "font-mBold main-m",
                  class: "mleft-04"
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_button_group, {
              key: 3,
              styles: "border-m pad-s",
              class: "mleft-auto psides-10",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (unvalidateTask()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: "Reprendre mission",
                  styles: "font-mBold main-m"
                })
              ]),
              _: 1
            }))
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "scrollbox",
      ref: scrollbox,
      class: "scrollbox mtop-06"
    }, [
      _createElementVNode("div", _hoisted_8, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"margin-top":"auto"} }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskNotes.value, (taskNote, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            ((index === 0 || taskNotes.value[index - 1].read === true) && !taskNote.read)
              ? (_openBlock(), _createBlock(_component_text_item, {
                  key: 0,
                  txt: "Non lus",
                  styles: "font-mBold main-h",
                  class: "mtop-10 mleft-04"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["bg-bigcard taskNote", taskNote.appUserNoteCreator.personWithRoleId === appUserPwrId.value ? 'mleft-auto' : ''])
              }, [
                _createElementVNode("div", _hoisted_10, [
                  (taskNote.appUserNoteCreator.personWithRoleId !== appUserPwrId.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_text_item, {
                          txt: taskNote.appUserNoteCreator.firstName,
                          styles: "font-mBold main-m",
                          class: "cursor-sel"
                        }, null, 8, ["txt"]),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mleft-04" }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_text_item, {
                    txt: _unref(formatUTCDateTimeToDate)(taskNote.updated),
                    styles: "font-s main-l",
                    class: "cursor-sel mleft-auto"
                  }, null, 8, ["txt"]),
                  _createVNode(_component_text_item, {
                    txt: _unref(formatUTCDateTimeToTime)(taskNote.updated),
                    styles: "font-s main-l",
                    class: "cursor-sel"
                  }, null, 8, ["txt"])
                ]),
                _createVNode(_component_text_item, {
                  txt: taskNote.noteContent,
                  styles: "font-m main-h",
                  class: "linebreak mtop-03 cursor-sel"
                }, null, 8, ["txt"])
              ], 2)
            ])
          ], 64))
        }), 128)),
        _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"height":"0.4rem","width":"1rem","flex-shrink":"0"} }, null, -1))
      ])
    ], 512),
    (localTaskStatus.value === 'Pending')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_inputBox, { class: "row w-full" }, {
            default: _withCtx(() => [
              _createVNode(_component_inputAreaAuto2, {
                ref_key: "focusRef",
                ref: focusRef,
                modelValue: taskNoteInputRef.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((taskNoteInputRef).value = $event)),
                placeholder: "Message ...",
                class: "w-full",
                onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (postMessage()), ["exact","prevent"]), ["enter"]))
              }, null, 8, ["modelValue"]),
              _cache[11] || (_cache[11] = _createElementVNode("div", {
                class: "line-v",
                style: {"margin-left":"auto"}
              }, null, -1)),
              _createVNode(_component_buttonGroup, {
                theme: "inline",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (postMessage()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "check",
                    styles: "size-l"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})